import axios from 'axios';
import MainURL from '../../../MainURL';

// P1 공고 알림 API (server/routers/alerts/jobAlerts.js) — 로그인 토큰은 authInterceptor 가 붙인다

export type Dict = Record<string, string>;

export interface AlertOptions {
  regions: Dict;
  positions: Dict;
  payBands: Dict;
  employment: Dict;
  maxConditions: number;
}

export interface AlertCondition {
  id?: number;
  name: string | null;
  regions: string[];
  positions: string[];
  payBands: string[];
  employment: string[];
  active?: boolean;
}

export interface AlertPreview {
  count: number;
  samples: { path: string; title: string; church: string; region: string }[];
}

const base = `${MainURL}/alerts`;

export const jobAlertsApi = {
  options: () => axios.get<AlertOptions>(`${base}/options`).then((r) => r.data),
  list: () =>
    axios
      .get<{ items: AlertCondition[]; lastDigest: { at: string; count: number } | null }>(`${base}/conditions`)
      .then((r) => r.data),
  preview: (cond: AlertCondition) => axios.post<AlertPreview>(`${base}/preview`, cond).then((r) => r.data),
  create: (cond: AlertCondition) => axios.post(`${base}/conditions`, cond),
  update: (id: number, cond: AlertCondition) => axios.put(`${base}/conditions/${id}`, cond),
  remove: (id: number) => axios.delete(`${base}/conditions/${id}`),
};

export const EMPTY_CONDITION: AlertCondition = { name: '', regions: [], positions: [], payBands: [], employment: [] };

/** 조건 요약 문구 — "서울·경기 · 부목사 · 전임" */
export function describeCondition(c: AlertCondition, o: AlertOptions | null) {
  if (!o) return '';
  const part = (codes: string[], dict: Dict) => codes.map((x) => dict[x]).filter(Boolean).join('·');
  return [part(c.regions, o.regions), part(c.positions, o.positions), part(c.payBands, o.payBands), part(c.employment, o.employment)]
    .filter(Boolean)
    .join(' · ') || '모든 공고';
}

export const errorText = (e: unknown, fallback = '처리하지 못했습니다.') =>
  (axios.isAxiosError(e) && (e.response?.data as { error?: string })?.error) || fallback;
